import { BitwiseTool } from '@/components/bitwise/BitwiseTool';

const Index = () => {
  return <BitwiseTool />;
};

export default Index;
